import React, { useState } from 'react';
import { ChoiceList } from './widgets/ChoiceList';
import { removeProsodyMarkdown } from '../units/parseUnits';

interface SystemSpeechProps {
  readonly input: string;
}

/**
 * use the native speech synthesizer (thru the Web API) to speak English text (NOT IPA),
 * UI is a button to trigger speech & a list of available voices to pick from
 */
export function SystemSpeech(props: SystemSpeechProps) {
  const [voices] = useState(window.speechSynthesis.getVoices());
  const [currentVoice, setCurrentVoice] = useState(voices[0]);
  const [voiceNames] = useState(voices.map(v => v.name));
  const [selectedName, setSelectedName] = useState(voiceNames[0]);

  function systemSpeech(input: string) {
    const s = removeProsodyMarkdown(input);
    const synth = window.speechSynthesis;
    const utter = new SpeechSynthesisUtterance(s);
    utter.voice = currentVoice;
    synth.speak(utter);
  }

  function changeVoice(name: string) {
    setSelectedName(name);
    const voice = voices.find(v => v.name === name);
    if (voice !== undefined) {
      setCurrentVoice(voice);
    }
  }

  return (<>
    system synthesizer:&nbsp;
    <button onClick={() => systemSpeech(props.input)}>speak input</button>
    &nbsp;&nbsp;
    <ChoiceList items={voiceNames} selectedItem={selectedName} onSelect={changeVoice} />
  </>);
}
